import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactOurExpertsComponent } from './contact-our-experts.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ContactOurExpertsComponent],
  imports: [CommonModule, I18nModule, RouterModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ContactOurExperts: {
          component: ContactOurExpertsComponent,
        },
      },
    }),
  ],
})
export class ContactOurExpertsModule {}
